// Initialize moment globally before any other imports
// This is required for moment-timezone to work correctly with Vite
import moment from 'moment';

// Make moment available globally
window.moment = moment;
globalThis.moment = moment;

export default moment;
